import { useAppText } from "src/commun/composants/AppText";
import { AppSelectOption } from "src/commun/composants/formulaire/AppSelect/AppSelect";

export const TITRE_MONSIEUR = "MONSIEUR";
export const TITRE_MADAME = "MADAME";

export type Title = "MADAME" | "MONSIEUR";
const useTitreOptions = () => {
  const { tString } = useAppText();

  return [
    {value: TITRE_MONSIEUR, label: tString('TitreCivil.MONSIEUR')},
    {value: TITRE_MADAME, label: tString('TitreCivil.MADAME')}
  ] as AppSelectOption[];
};

export default useTitreOptions;
